import React from "react";

import { camelCase } from "lodash";
import { useTranslation } from "react-i18next";

import { DateFormat } from "@/components/atoms";

import { getExpirationDateWarningColor } from "../../utils/getExpirationDateWarningColor";
import { StyledSignButton } from "../PackagesTableItem/styled";
import useConnectiveUrl from "../PackagesTableItem/useConnectiveUrl";
import { StyledPackageCard, StyledPackagePrice } from "./styled";

const PackageCard = ({ packageToSign }: { packageToSign: MyBrokerApi.DocumentsPackageToSign }) => {
    const { t } = useTranslation();
    const { connectiveUrlLoading, connectiveUrlClicked } = useConnectiveUrl({ pkg: packageToSign });

    const expirationDateColor = getExpirationDateWarningColor(packageToSign.expirationDate);

    return (
        <StyledPackageCard
            clickable={false}
            dataTestId={`package_cards-card-${packageToSign.guid}`}
            title={packageToSign.name}
            infos={[
                {
                    title: t("Common.Concerns"),
                    content: packageToSign.documentsList[0].policyHolder,
                },
                { title: t("Common.RequestDate"), content: <DateFormat date={packageToSign.requestDate} /> },
                {
                    title: t("Common.ExpirationDate"),
                    content: (
                        <span style={{ color: expirationDateColor }}>
                            <DateFormat date={packageToSign.expirationDate} />
                        </span>
                    ),
                },
            ]}
        >
            <StyledPackagePrice className="highlightText" data-testid="card-package_price">
                <StyledSignButton
                    disabled={connectiveUrlLoading}
                    classes={{ root: "button-root" }}
                    onClick={connectiveUrlClicked}
                    data-testid={`package_sign_button-item-${camelCase(packageToSign.guid)}`}
                >
                    {t("ToSign.Confirm.Sign")}
                </StyledSignButton>
            </StyledPackagePrice>
        </StyledPackageCard>
    );
};

export default PackageCard;
